/* Info component on the Edit Callsheet form
   telling users that the Add Cast and Add Background forms are 
   seperate from the main Callsheet form */
import React from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import styles from "../../../styles/Callsheets.module.css";

const InformationEdit = () => {
  return (
    <div>
        <Row className='mb-3'>
            <Col className={`px-3 py-2 ${styles.SubTitle6 }`}
             md={{span: 10, offset: 1 }}>
              <h5 className={`text-center ${styles.Red }`} >CALLSHEET ADD/EDIT INFO</h5>  
              <hr className={`mt-2 mb-0`}/>
        <p className='pt-2'><span className={`${styles.Red}`}></span>The Callsheet Add/Edit page is divided into 2 sections.</p>
        <p className='pt-3'>SECTION 1 - THE CAST & BG/STAND-INS FORMS</p>
        <p className="pt-2">
        <span className={`${styles.Red}`}>*</span> Click the <span className={`${styles.Red}`}>Add Cast</span> tab to add Cast and the <span className={`${styles.Red}`}>Add BG</span> tab to
        add BG/Stand-ins/Doubles. 
        </p>
        <p className={`${styles.Small} pt-2`}>
        <span className={`${styles.Red}`}>*</span> Stunt Performers should be handled by the <span className={`${styles.Red}`}>Stunt Coordinator</span>.
        </p>
        <p className='pt-4'>SECTION 2 - THE MAIN CALLSHEET FORM 
        </p>
        <p className="pt-2">
        <span className={`${styles.Red}`}>*</span><span className={`${styles.Red}`}> Crew</span> are added 
        here in the Crew Calltime section.
        </p>
        <p className="pt-2">
        <span className={`${styles.Red}`}>*</span> The <span className={`${styles.Red}`}>Schedule and Locations</span> are automatically
        added.
        </p>
        <p className="pt-2">
        <span className={`${styles.Red}`}>*</span> The Hospitals Dropdown and Walkies Channels are set on the Callsheets page
        which contains their related info.
        </p>
        <p className="pt-2">
        <span className={`${styles.Red}`}>*</span> Use the <span className={`${styles.Red}`}>Advanced Schedule</span> Dropdown 
        to add the next Shoot Day for the Advanced Schedule.
        </p>
        <p className={`${styles.Small} pt-3`}>
        <span className={`${styles.Red}`}>*</span> Callsheet <span className={`${styles.Red}`}>Crew </span> must be added to the
        Crew Info section and <span className={`${styles.Red}`}>Cast</span> must be added to their Character page. 
        </p>
        <hr className={`mt-2 mb-0`}/>
        </Col>
      </Row>
    </div>
  )
}

export default InformationEdit